module.exports = __webpack_public_path__ + "img/5f89831818dcb71775e1b3ea_hamburger-white.faa7b508.svg";